import type {ContainerQueryObject} from "@Hooks/useContainerQuery";
import type {LoadingStates} from "@Utils/loading.util";
import type {SocialMediaProfileLinksMap} from "@Components/social-media-profile-links/social-media-profile-links.types";
import type {FollowerUpdateFrequency} from "@Components/mystuff-events-home/components/events-calendar-follower-settings/events-calendar-follower-settings.types";

export const EVENTS_HOME_IFRAME_JS_CLASS = 'js-events-home-iframe';
export const EVENTS_HOME_IFRAME_IN_MODAL_JS_CLASS = 'js-events-home-iframe-in-modal';

export const containerQuery: ContainerQueryObject = {
    small: {
        minWidth: 0,
        maxWidth: 500
    },

    emptyStateSmall: {
        minWidth: 0,
        maxWidth: 580
    },

    emptyStateMedium: {
        minWidth: 581,
        maxWidth: 750
    },

    emptyStateLarge: {
        minWidth: 751,
        maxWidth: 900
    }
    // emptyStateSmall: bannerContainerQuery.small,
    // emptyStateMedium: bannerContainerQuery.medium
}
export interface MystuffEventsHomeProps {
// add props here
}

export enum EventsHomeEditingStep {
    PAGE = 1,
    CONTACT = 2
}

export enum EventsCalendarPageLayout {
    LIST = 'list',
    CALENDAR = 'calendar',
    GRID = 'grid'
}

export enum EventsCalendarEditSource {
  MY_EVENTS_TILE = 'My_Events_Tile',
  CALENDAR_MY_STUFF = 'Calendar_My_Stuff',
  CALENDAR_PAGE = 'Calendar_Page',
}

export enum EventsCalendarShareType {
  COPY_LINK = 'Copy',
  EMBED_ON_WEBPAGE = 'Embed',
  SHARE_TO_FACEBOOK = 'Facebook',
  SHARE_TO_X = 'X',
  SHARE_TO_LINKEDIN = 'Linkedin',
  SHARE_TO_WHATSAPP = 'Whatsapp',
}

export interface EventsHomePageStyle {
    color: string;
    fontFamily: string;
    imageURL?: string;
    coverPhotoURL?: string;
}

export interface PageDetailsFormData extends EventsHomePageStyle {
    title: string;
    description: string;
    doRemoveWatermark: boolean;
    doShowPastEvents: boolean;
    eventsCalendarLayoutPreference: EventsCalendarPageLayout;
    doShowLocationColumn: boolean;
    doShowActionsColumn: boolean;
    doShowFollowButton: boolean;
    followerUpdateFrequency: FollowerUpdateFrequency;
    mailingListId: string | null;
}

export interface ContactDetailsFormData {
    email: string;
    phoneNumber: string;
    socialMediaProfilesInput: SocialMediaProfileLinksMap
}

export interface EventsHomeReduxState {
    isEditing: boolean;
    wizardCurrentStep: EventsHomeEditingStep;
    eventsHomeHashedId: string;
    pageDetailsFormData: PageDetailsFormData;
    contactDetailsFormData: ContactDetailsFormData;
    loadingState: LoadingStates;
    isFormInErrorState: boolean;
    recentEmailsUsed: string[];
    recentPhoneNumbersUsed: string[];
    isEmptyState: boolean;
    savedEventsScheduleVO?: UserEventsScheduleVO;
}

export interface UserEventsScheduleVO {
    hashedID: string;
    title: string;
    email: string;
    doShowLocation: boolean;
    doShowActions: boolean;
    description?: string;
    doRemoveWatermark?: boolean;
    doShowPastEvents?: boolean;
    phoneNumber?: string;
    socialProfileLinks: Record<string, string>;
    primaryColor?: string;
    secondaryColor?: string;
    profilePictureURL?: string;
    coverPhotoURL?: string;
    fontFamily?: string;
    teamID?: string;
    brandID?: string | null;
    viewType?: EventsCalendarPageLayout;
    doShowFollowButton?: boolean;
    followerUpdateFrequency?: FollowerUpdateFrequency;
    mailingListId?: string | null;
    idEmailSignupForm?: string | null;
}

export interface EventsHomePageMetaBackendResponse {
    userEventsSchedule?: UserEventsScheduleVO;
    emailSuggestions: string[];
    phoneNumberSuggestions: string[];
}